import React from 'react';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const DropboxOutline: React.FC<Props> = ({ width, height, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
    >
      <g fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            d="M8.865 4L4 7.135l3.333 2.532L12 6.697 8.865 4zM12 6.698l4.896 2.833L20 7l-4.73-3L12 6.698zm4.896 2.833L12 12.604l3.198 2.427L20 12.167 16.896 9.53zM12 12.604L7.333 9.667 4 12.167l4.865 2.864L12 12.604zm0 .834l-2.73 2.124c-.116.09-.258.136-.405.136-.119 0-.23-.034-.334-.094L6.667 14.51v1.855c0 .112.052.218.146.28l5 3.303c.055.036.123.052.187.052s.133-.016.188-.052l5-3.27c.093-.062.145-.169.145-.282V14.53l-1.791 1.073c-.103.063-.224.094-.344.094-.146 0-.29-.048-.406-.136L12 13.438z"
            transform="translate(-158 -338) translate(126 23) translate(32 220) translate(0 95)"
          />
        </g>
      </g>
    </svg>
  );
};

export default DropboxOutline;
